<template>
  <div class="ds-container">
    
    <ul class="nav nav-pills">
      <li class="nav-item" v-for="(menu, findx) in settingsMenu" :key="findx">
        <a 
          href="#" 
          class="nav-link" 
          :class="{ active: activeMenu === menu.name }"
          @click="setActiveMenu(menu.name)">
          {{ menu.label }}
        </a>
      </li>
    </ul>

    <hr>

    <CategoriesTab
      v-if="activeMenu === 'categorias'"
    />

    <ProductRegistration
      v-if="activeMenu === 'cadastro-produtos'"
    />

    <GeneralSettings
      v-if="activeMenu === 'configuracoes-gerais'"
    />

    <Manufacturer
      v-if="activeMenu === 'fabricantes'"
    />

    <MultipleStock
      v-if="activeMenu === 'estoque_subestoque'"
    />
    

  </div>      
</template>
<script>
import { userHasPermission, getCurrentClinic } from '@/utils/localStorageManager'

export default {
  components: {
    CategoriesTab: () => import('./Configurations/CategoriesTab.vue'),
    ProductRegistration: () => import('./Configurations/ProductRegistration.vue'),
    GeneralSettings: () => import('./Configurations/GeneralSettings.vue'),
    Manufacturer: () => import('./Configurations/Manufacturer.vue'),    
    MultipleStock: () => import('./Configurations/MultipleStock.vue'),    
  },
  mounted() {
    this.getWarehouseConfigurations();
  },
  data() {
    return {
      canEditModule: userHasPermission('EstConf2'),
      canEditPreferences: userHasPermission('EstConf3'),
      clinic: getCurrentClinic(),
      selectedFields: {},
      settingsMenu: [
        { label: 'Cadastro de Produtos', name: 'cadastro-produtos' },
        { label: 'Categorias', name: 'categorias' },
        { label: 'Estoque / Subestoque', name: 'estoque_subestoque' },
        { label: 'Fabricantes', name: 'fabricantes' },
        { label: 'Configurações Gerais', name: 'configuracoes-gerais' }
      ],
      activeMenu: 'cadastro-produtos',
      activeAccordionId: '',
      form: {},
      categories: [],
    }
  },
  methods: {
    setActiveMenu(menu) {
      this.activeMenu = menu;
    },
    getWarehouseConfigurations() {
      const isLoading = this.$loading.show();
      this.api.getWarehouseConfigurations(this.clinic.id)
      .then(res => {
        this.form = res.data;
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => isLoading.hide());
    },
    updateWarehouseConfigurations(props) {
      this.api.updateWarehouseConfigurations(this.form.id, props)
      .then(() => {
        this.$toast.success('Configuração atualizada com sucesso.');
      })
      .catch(err => this.$toast.error(err.message));
    },
    updateRequiredProductField(){
      this.updateWarehouseConfigurations({
        required_fields: this.selectedFields
      })      
    },
    activate(event){
      this.activeAccordionId = event.currentTarget.id;
    }  
  },
}
</script>
<style lang="scss" src="@/assets/scss/table.scss" />
<style lang="scss" scoped>
.ds-container {
    padding: 30px 10px;

    .ds-header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 35px 0px 10px 0px;
    }

    .ds-title {
      display: inline-flex;
      align-items: center;
      font-family: 'Red Hat Display';
      font-weight: 500;
      font-size: 18px;
    }

    .nav-link {
      font-size: 14px;
      margin: 2px 3px;
      padding: 0 10px;
      border: 1px solid #D9DFF2;
      border-radius: 100px;
      cursor: pointer;
      color: var(--type-active);

      &.active {
        background-color: #F4F5FB;
      }
    }

  .table {
    border: 1px solid #C6CEEB;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;

    thead {
      th {
        background: #F4F5FB;
        color: #525C7A;
        border: none;
        border-bottom: 1px solid #dee2e6;
      }
    }

    tbody {
      td {
        padding: 0.35rem;
        vertical-align: middle;
        color: #525C7A;
        height: 45px;
        border: none;
        border-bottom: 1px solid #dee2e6;

        .link-add {
          color: #305BF2;
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
        }

        .default {
          color: #8696AC;
          font-size: 12px;
        }

      }
    }
  }

}
</style>
